module.exports = __webpack_public_path__ + "files/2523d7f43697a2fb588b18d6260356fb.png";